(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7821],{

/***/ 1530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print/faq",
      function () {
        return __webpack_require__(33905);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ fetchBoards; }
/* harmony export */ });
/* unused harmony export ViewSetBoard */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchBoards = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Data) === null || ref2 === void 0 ? void 0 : ref2.rows
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBoards(body) {
        return _ref.apply(this, arguments);
    };
}();
var ViewSetBoard = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ViewSetBoard(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 85134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ smallPackagingFileAPI; },
/* harmony export */   "t": function() { return /* binding */ smallPackagingAPI; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var smallPackagingAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SMALLPACKAGING */ .Z.SMALLPACKAGING).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function smallPackagingAPI(body) {
        return _ref.apply(this, arguments);
    };
}();
var smallPackagingFileAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SMALLPACKAGING */ .Z.SMALLPACKAGING).postFiles(body);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function smallPackagingFileAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 56516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": function() { return /* binding */ FAQContent; },
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "UZ": function() { return /* binding */ FAQTop; },
/* harmony export */   "l5": function() { return /* binding */ FAQTitle; },
/* harmony export */   "y6": function() { return /* binding */ TableWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 2px solid black;\n  overflow-x: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-bottom: 1px solid #ececec;\n  color: black;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 0 2rem;\n  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  :hover {\n    background-color: #3bb77e;\n    color: white;\n  }\n  & i {\n    font-size: 1.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 5rem;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  border-top: 1px solid #ececec;\n  padding: 2rem 2rem;\n  font-weight: 300;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var TableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-0"
})(_templateObject());
var TableRow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-1"
})(_templateObject1());
var FAQTop = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-2"
})(_templateObject2(), function(props) {
    return props.isActive ? "#3bb77e" : "#fff";
}, function(props) {
    return props.isActive ? "#fff" : "black";
});
var FAQTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-3"
})(_templateObject3());
var FAQContent = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-4"
})(_templateObject4(), function(props) {
    return props.isActive ? "block" : "none";
});


/***/ }),

/***/ 52658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PrintDesignService; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32252);


var PrintDesignService = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .DesignBanner */ .fF, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "content container-lg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "textContent",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "\uB85C\uACE0\uAC00 \uC5C6\uB2E4\uBA74?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                            children: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "\uAC04\uB2E8\uD55C \uB85C\uACE0 \uBC30\uCE58\uBD80\uD130 \uBE0C\uB79C\uB4DC \uB514\uC790\uC778\uAE4C\uC9C0! ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " \uAC00\uACA9\uBCC4\uB85C \uB098\uC5D0\uAC8C \uB9DE\uB294 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "https://file.caretbio.com/caretbio/9ac7d2c8185a56a72ecf459b2021022a.png",
                            className: "m_banner"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "",
                            href: "/customizing/design-service/",
                            children: "\uC11C\uBE44\uC2A4 \uBCF4\uB7EC\uAC00\uAE30"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://file.caretbio.com/caretbio/47ffdb3584f54f4251b1c79b3aad90c1.png",
                    className: "pc_banner"
                })
            ]
        })
    });
};


/***/ }),

/***/ 48071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PrintTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32252);
/* harmony import */ var _hook_customizing_print_useTabStickyHandler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15634);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _hook_customizing_print_usePrintFaqQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39117);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _common_pageRouter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92534);
/* harmony import */ var _hook_customizing_print_usePrintProductListQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44756);








var ESTIMATE_TAB_TITLE = "\uACAC\uC801\uC694\uCCAD";
var ROOT_TITLE = "\uC18C\uB7C9\uC778\uC1C4";
var PrintTab = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var tabHeaderRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var isSticky = (0,_hook_customizing_print_useTabStickyHandler__WEBPACK_IMPORTED_MODULE_2__/* .useTabStickyHandler */ .h)(tabHeaderRef).isSticky;
    // FAQ (로딩이 끝난 뒤에만 조회하도록 isReady 전달)
    var ref2 = (0,_hook_customizing_print_usePrintFaqQuery__WEBPACK_IMPORTED_MODULE_4__/* .usePrintFaqQuery */ .p)(router.isReady), faqList = ref2.data;
    // 장바구니 아이템 구독 (react-query)
    var ref1 = (0,_hook_customizing_print_usePrintProductListQuery__WEBPACK_IMPORTED_MODULE_7__/* .usePrintCartItemsQuery */ .J)(), tmp = ref1.data, printCartItems = tmp === void 0 ? [] : tmp;
    // 배지용 카운트 (원하는 기준으로 사용)
    var cartItemCount = printCartItems.length; // 서로 다른 상품 개수
    // const cartQtySum = printCartItems.reduce((acc, cur) => acc + (Number(cur.cnt) || 0), 0); // 총 수량 합계
    // "소량인쇄" 하위 탭
    var tabRouter = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var ref;
        return ((ref = _common_pageRouter__WEBPACK_IMPORTED_MODULE_6__/* .PageRouter.find */ .L.find(function(item) {
            return item.title === ROOT_TITLE;
        })) === null || ref === void 0 ? void 0 : ref.sub) || [];
    }, []);
    // FAQ 없으면 FAQ 탭 제거
    var tabs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!faqList) return tabRouter;
        return faqList.length === 0 ? tabRouter.filter(function(tab) {
            return tab.title !== "\uC18C\uB7C9\uC778\uC1C4 FAQ";
        }) : tabRouter;
    }, [
        faqList,
        tabRouter
    ]);
    var onChangeMainTab = function(tab) {
        if ((tab === null || tab === void 0 ? void 0 : tab.url) && tab.url !== router.pathname) {
            router.push(tab.url);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .TabContainer */ .Xl, {
        ref: tabHeaderRef,
        isSticky: isSticky,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .TabHeader */ .GK, {
            children: tabs.map(function(tab) {
                var isActive = router.pathname === (tab === null || tab === void 0 ? void 0 : tab.url);
                var isEstimateTab = (tab === null || tab === void 0 ? void 0 : tab.title) === ESTIMATE_TAB_TITLE;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .TabItem */ .E2, {
                    active: isActive,
                    onClick: function() {
                        return onChangeMainTab(tab);
                    },
                    style: {
                        position: "relative"
                    },
                    children: [
                        tab === null || tab === void 0 ? void 0 : tab.title,
                        isEstimateTab && cartItemCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                marginLeft: 8,
                                display: "inline-block",
                                minWidth: 18,
                                padding: "0 6px",
                                height: 18,
                                lineHeight: "18px",
                                borderRadius: 9,
                                fontSize: 12,
                                textAlign: "center",
                                background: "#ef4444",
                                color: "#fff",
                                verticalAlign: "middle"
                            },
                            children: cartItemCount
                        })
                    ]
                }, (tab === null || tab === void 0 ? void 0 : tab.url) || (tab === null || tab === void 0 ? void 0 : tab.title));
            })
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (PrintTab)));


/***/ }),

/***/ 39117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ usePrintFaqQuery; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);
/* harmony import */ var _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51586);
/* harmony import */ var _api_boards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67623);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var usePrintFaqQuery = function() {
    var enabledCondition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.CUSTOMIZING.PRINT.FAQ */ .U.CUSTOMIZING.PRINT.FAQ,
        queryFn: _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "List",
                            boardName: "sfaq"
                        };
                        _ctx.next = 3;
                        return (0,_api_boards__WEBPACK_IMPORTED_MODULE_2__/* .fetchBoards */ .P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!(res.Code === "0000" || res.code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", res.data.data);
                    case 8:
                        return _ctx.abrupt("return", []);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        retry: 1,
        enabled: enabledCondition,
        cacheTime: 1000 * 60 * 30
    });
};


/***/ }),

/***/ 44756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ usePrintCartItemsQuery; },
/* harmony export */   "u": function() { return /* binding */ usePrintProductListQuery; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);
/* harmony import */ var _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51586);
/* harmony import */ var _api_smallPackaging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85134);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var usePrintProductListQuery = function() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.CUSTOMIZING.PRINT.PRODUCTS */ .U.CUSTOMIZING.PRINT.PRODUCTS
        ],
        queryFn: _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, body, res, ref1;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        body = {
                            modes: "ProductsListSet"
                        };
                        _ctx.next = 4;
                        return (0,_api_smallPackaging__WEBPACK_IMPORTED_MODULE_2__/* .smallPackagingAPI */ .t)(body);
                    case 4:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", (ref1 = res.Data) === null || ref1 === void 0 ? void 0 : ref1.rows.data);
                    case 8:
                        throw new Error(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uC0C1\uD488 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
};
var usePrintCartItemsQuery = function() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.CUSTOMIZING.PRINT.CART */ .U.CUSTOMIZING.PRINT.CART
        ],
        queryFn: function() {
            var items = JSON.parse(sessionStorage.getItem("printCart") || "[]");
            return items;
        },
        enabled: "object" !== "undefined"
    });
};


/***/ }),

/***/ 33905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44027);
/* harmony import */ var _components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32252);
/* harmony import */ var _components_csboard_faq_faq_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56516);
/* harmony import */ var _hook_customizing_print_usePrintFaqQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39117);
/* harmony import */ var _components_layout_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32511);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _components_customizing_print_PrintDesignService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52658);
/* harmony import */ var _components_customizing_print_printTab_PrintTab__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48071);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);










var PrictFAQPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var ref = (0,_hook_customizing_print_usePrintFaqQuery__WEBPACK_IMPORTED_MODULE_4__/* .usePrintFaqQuery */ .p)(router.isReady), faqList = ref.data, isLoading = ref.isLoading, error = ref.error; //faq 리스트
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), isActive = ref1[0], setIsActive = ref1[1]; //faq
    var onClickOpenFAQ = function(i) {
        return function() {
            if (isActive !== i) setIsActive(i);
            if (isActive === i) setIsActive("");
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        parent: "\uD648",
        sub: "\uC18C\uB7C9\uC778\uC1C4",
        subTitle: "\uC18C\uB7C9\uC778\uC1C4 FAQ",
        pageTitle: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_1__/* .SeoMeta.smallPrintServiceFAQ.title */ .e.smallPrintServiceFAQ.title,
        pageDesc: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_1__/* .SeoMeta.smallPrintServiceFAQ.description */ .e.smallPrintServiceFAQ.description,
        pageKeyword: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_1__/* .SeoMeta.smallPrintServiceFAQ.keywords */ .e.smallPrintServiceFAQ.keywords,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_printTab_PrintTab__WEBPACK_IMPORTED_MODULE_8__/* .PrintTab */ .d, {}),
            Array.isArray(faqList) && faqList.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container mb-50",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .NormalTitle */ .XG, {
                        children: [
                            "\uC18C\uB7C9\uC778\uC1C4 ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "FAQ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_csboard_faq_faq_styles__WEBPACK_IMPORTED_MODULE_3__/* .TableWrapper */ .y6, {
                        children: faqList.map(function(el, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_csboard_faq_faq_styles__WEBPACK_IMPORTED_MODULE_3__/* .TableRow */ .SC, {
                                onClick: onClickOpenFAQ(i),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_csboard_faq_faq_styles__WEBPACK_IMPORTED_MODULE_3__/* .FAQTop */ .UZ, {
                                        isActive: isActive === i,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_csboard_faq_faq_styles__WEBPACK_IMPORTED_MODULE_3__/* .FAQTitle */ .l5, {
                                                children: [
                                                    el.category,
                                                    el.title
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: isActive === i ? "fi-rs-angle-small-up" : "fi-rs-angle-small-down"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_csboard_faq_faq_styles__WEBPACK_IMPORTED_MODULE_3__/* .FAQContent */ .C9, {
                                        isActive: isActive === i,
                                        dangerouslySetInnerHTML: {
                                            __html: el.contents
                                        }
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_PrintDesignService__WEBPACK_IMPORTED_MODULE_7__/* .PrintDesignService */ .$, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PrictFAQPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4027,9007,9774,2888,179], function() { return __webpack_exec__(1530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);